// vee-validate rules used by the member-review forms (ported from the rep dashboard)
// that this app does not register globally in utlis/validator.js.
import { extend } from 'vee-validate';
import { alpha, alpha_spaces, numeric, digits, length, min_value, max_value, size } from 'vee-validate/dist/rules';

extend('alpha', alpha);
extend('alpha_spaces', alpha_spaces);
extend('numeric', numeric);
extend('digits', digits);
extend('length', length);
extend('min_value', min_value);
extend('max_value', max_value);
extend('size', size);
